import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketStatus } from '../../../core/models/ticket.model';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span [class]="badgeClasses()">
      <span class="w-1.5 h-1.5 rounded-full mr-1.5" [class]="dotClasses()"></span>
      {{ label() }}
    </span>
  `
})
export class StatusBadgeComponent {
  readonly status = input.required<TicketStatus>();

  readonly label = computed(() => {
    switch (this.status()) {
      case 'Open': return 'Open';
      case 'In Progress': return 'In Progress';
      case 'On Hold': return 'On Hold';
      case 'Resolved': return 'Resolved';
      case 'Closed': return 'Closed';
      case 'Cancelled': return 'Cancelled';
      default: return this.status();
    }
  });

  readonly badgeClasses = computed(() => {
    const base = 'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold tracking-wide transition-colors';
    switch (this.status()) {
      case 'Open': return `${base} bg-blue-50 text-blue-700 border border-blue-200`;
      case 'In Progress': return `${base} bg-amber-50 text-amber-700 border border-amber-200`;
      case 'On Hold': return `${base} bg-purple-50 text-purple-700 border border-purple-200`;
      case 'Resolved': return `${base} bg-emerald-50 text-emerald-700 border border-emerald-200`;
      case 'Closed': return `${base} bg-gray-100 text-gray-700 border border-gray-200`;
      case 'Cancelled': return `${base} bg-gray-100 text-gray-700 border border-gray-200`;
      default: return `${base} bg-gray-100 text-gray-700`;
    }
  });

  readonly dotClasses = computed(() => {
    switch (this.status()) {
      case 'Open': return 'bg-blue-500 animate-pulse';
      case 'In Progress': return 'bg-amber-500';
      case 'On Hold': return 'bg-purple-500';
      case 'Resolved': return 'bg-emerald-500';
      case 'Closed': return 'bg-gray-400';
      case 'Cancelled': return 'bg-gray-400';
      default: return 'bg-gray-400';
    }
  });
}
